import { render, staticRenderFns } from "./OrderDocumentInfoButtonPublic.vue?vue&type=template&id=0558191a"
import script from "./OrderDocumentInfoButtonPublic.vue?vue&type=script&lang=js"
export * from "./OrderDocumentInfoButtonPublic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports